import React from 'react';
import { InstagramIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { DEALERSHIP } from '../data/dealership';
import { INSTAGRAM_URL, PRIVACY_POLICY_URL, TERMS_URL, DEALER_DISCLOSURE } from '../config';
export function Footer() {
  const {
    t,
    lang
  } = useLanguage();
  const year = new Date().getFullYear();
  return <footer className="w-full bg-ink" data-id="element-53" data-mp="36nd1b5fv1nxc">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 sm:px-6" data-id="element-54" data-mp="3uesbfkdvp9j5">
        <p className="font-display text-sm font-extrabold uppercase tracking-[0.2em] text-white" data-id="element-55" data-mp="38qw2zmvrtrp">
          MIAMI CAR QUEENS
        </p>
        <p className="mt-2 text-sm text-white/65" data-id="element-56" data-mp="3lf5bl30ssbs7">{t('footer.people')}</p>
        <p className="mt-1 text-xs uppercase tracking-[0.16em] text-white/45" data-id="element-57" data-mp="3qd6qdbr6xoxv">
          {t('footer.services')}
        </p>

        <div className="mt-8 h-px w-full bg-camel/40" data-id="element-58" data-mp="29yxaz74xfaj6" />

        {/* The dealership where Gabriela and Chanira work. Miami Car Queens is NOT a dealership. */}
        <div className="mt-8" data-id="element-59" data-mp="2evxbz3mx5n3f">
          <p className="text-[11px] uppercase tracking-[0.2em] text-camel" data-id="element-60" data-mp="3l8qvi1vp0fqe">
            {t('footer.dealerLabel')}
          </p>
          <p className="mt-2 font-display text-base font-bold text-white" data-id="element-61" data-mp="3gc0g7grppo61">{DEALERSHIP.name}</p>
          <p className="mt-1 text-sm text-white/65" data-id="element-62" data-mp="3v8hq03k96uqh">{DEALERSHIP.address}</p>
          <p className="mt-1 text-sm text-white/65" data-id="element-63" data-mp="3q8div458jccx">{DEALERSHIP.hours[lang]}</p>
          <p className="mt-3 max-w-xl text-xs leading-relaxed text-white/45" data-id="element-64" data-mp="82qu9y9z03wd">
            {t('footer.notDealer')}
          </p>
        </div>

        <div className="mt-8 flex flex-wrap items-center gap-x-5 gap-y-1 text-xs text-white/60" data-id="element-65" data-mp="335pv8c173c9">
          {/* Rendered only when the config URL is non-empty. */}
          {INSTAGRAM_URL ? <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="flex min-h-[44px] items-center gap-2 hover:text-gold" data-id="element-66" data-mp="cv1qaq1lb5jn">
              <InstagramIcon aria-hidden="true" className="h-4 w-4" data-id="element-67" data-mp="mthhet0maet5" />
              {t('footer.instagram')}
            </a> : null}
          {PRIVACY_POLICY_URL ? <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer" className="flex min-h-[44px] items-center hover:text-gold" data-id="element-68" data-mp="yv935q2bruu6">
              {t('form.privacy')}
            </a> : null}
          {TERMS_URL ? <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" className="flex min-h-[44px] items-center hover:text-gold" data-id="element-69" data-mp="1ckt2elwp69yq">
              {t('form.terms')}
            </a> : null}
        </div>

        {/* Small print, rendered only if the disclosure constant is non-empty. */}
        {DEALER_DISCLOSURE ? <p className="mt-6 max-w-3xl text-[11px] leading-relaxed text-white/40" data-id="element-70" data-mp="3ocgh0llhr757">
            {DEALER_DISCLOSURE}
          </p> : null}

        <p className="mt-6 text-[11px] text-white/35" data-id="element-71" data-mp="2af3qfjjjwrgg">© {year} Miami Car Queens</p>
      </div>
    </footer>;
}